import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Download an Excel file from an API endpoint.
 * @param {string} url - Relative API path (e.g., "/export/planning-report")
 * @param {string} fallbackFilename - Fallback filename
 * @param {object} options - { method: 'GET'|'POST', params: {}, data: {} }
 */
export async function downloadExcel(url, fallbackFilename, options = {}) {
  const { method = "GET", params, data } = options;
  try {
    const response = await axios({
      method,
      url: `${API}${url}`,
      params,
      data,
      responseType: "blob",
      timeout: 120000,
    });

    const contentDisposition = response.headers["content-disposition"];
    let filename = fallbackFilename;
    if (contentDisposition) {
      const match = contentDisposition.match(/filename=(.+)/);
      if (match) filename = match[1];
    }

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);

    toast.success("Excel downloaded successfully");
  } catch (error) {
    toast.error(`Export failed: ${error.message}`);
  }
}
